module.exports = __webpack_public_path__ + "20230117/img/defaultLogo.4fc2ca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/defaultLogo.png
// module id = tTNO
// module chunks = 1